import { Component, OnInit, ViewChild, ElementRef, OnDestroy, DoCheck } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';
import { PlatformLocation } from '@angular/common';
import { ClientsService, ProcessAssessmentDto, SaveQuestionDto } from 'app/services/client/ClientsService';
import { AssessmentsService } from 'app/services/assessment/AssessmentsService';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { TranslateService } from '@ngx-translate/core';
import { RatersService } from '../../services/rater/RatersService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';


@Component({
  selector: 'app-assigned-assessment',
  templateUrl: './assigned-assessment.component.html',
  styleUrls: ['./assigned-assessment.component.scss']
})
export class AssignedAssessmentComponent implements OnInit, OnDestroy, DoCheck {

    @ViewChild('selects', {static: false}) selectsElement: ElementRef;

    // instruction
    from: string;
    assessmentId = -1;
    assignmentId: number;
    hasId = false;
    once = true;

    ready = false;
    // instruction


    finish = false;
    questionsTotal = 0;
    from_client: boolean;
    from_admin: boolean;
    previewMode: boolean;
    showAssessment = false;
    loading = true;
    questionsContent = true;
    showNextIcon = true;
    currentQuestionId = 0;
    currentSectionId = 0;
    currentQuestionIndex = 0;
    currentSectionIndex = 0;
    showIcons: boolean;
    singleChoice: boolean;
    displayMode: number;

    sections: any[] = [];
    currentSectionChoices: any[] = [];
    multipleQuestions: any[] = [];
    questionChoices: any[] = [];

    globalCurrentQuestion = 1;
    currentChoiceSetId: number;

    assessmenProcess: any[] = [];

    showDownButtons = false;
    responsiveButtons = false;
    currentAssessmentName = '';

    // Graphic1
    ERGraphicDatasets: any[] = [];
    ERGraphicLabel: string[] = [];
    ERGraphicOptions: any = {
        scaleShowVerticalLines: true,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    beginAtZero: true
                }
            }]
        },
        tooltips: {
            enabled: true
        },
        hover: {
            animationDuration: 5
        }
    };

    ERGraphicLegend = false;
    ERGraphicChartType = 'horizontalBar';

    colors: Array<any> = [
        { // blue
            backgroundColor: '#1588eb',
            borderColor: 'rgba(0,192,192,1)',
            pointBorderColor: 'rgba(0,181,255,1)',
            pointBackgroundColor: 'rgba(255,255,255,1)',
            pointBorderWidth: 1,
        }
    ];

    // Graphic2
    ERPGraphicDatasets: any[] = [];
    ERPGraphicLabel: string[] = [];
    ERPGraphicOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    beginAtZero: true
                }
            }]
        },
    };
    ERPGraphicLegend = false;
    ERPGraphicChartType = 'horizontalBar';

    ARL: any;
    EP: any;
    ESR: any;

    loadingMessage = 'Loading Asessment, please wait...';
    graphicTitle1 = '';
    graphicTitle2 = '';

    levels1: any[] = [];
    levels2: any[] = [];

    userType: number;

    assessment360Finished = false;
    final360Message: string;

    selectModeClone: any;
    hideNavigationBtns = false;

    downloadTimer: any;
    timeleft = 900;
    currentHeader = '';
    language = '';
    data: any;
    pageContent: any;
    fullName: any;
    showCommentsSection = false;
    onCommentsPage = false;
    clientInfo = {
        FirstName: '',
        LastName: ''
    };
    showBanner = true;

    // ProcessAssessment returned -2 (missing answers)
    showMissingAnswers = false;
    missingAnswersCount = 0;
    reviewingMissingAnswers = false;
    // "Skip to Previous/Next Missing Answer" checkbox
    skipToMissingAnswers = false;
    // missing answers returned by ProcessAssessment (fixed list) and their positions in the sections array
    missingAnswers: any[] = [];
    missingPositions: { sectionIndex: number, questionIndex: number }[] = [];
    commentsText = '';

    gettingData = new Array<string>();
    progressRef: NgProgressRef;

    constructor
    (
        private _ClientsService: ClientsService,
        private _AssessmentsService: AssessmentsService,
        private _RatersService: RatersService,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private router: Router,
        private _Globals: Globals,
        location: PlatformLocation,
        public ngProgress: NgProgress,
        public translate: TranslateService,
        private _CryptoJs: CryptoJs,
    ) {
        this.progressRef = ngProgress.ref();
        this.activatedRoute.params.subscribe(params => {
            console.log('params', params);
            this.assessmentId = params['id'];
            this.from = params['from'];
            this.assignmentId = parseInt(params['assignmentId'], 10);
            this.currentAssessmentName = params['name'];
            this.language = params['language'];
            this.fullName = params['fullName'];

            if (Number(this.assessmentId) !== -1) {
                this.hasId = true;
            }

            translate.use(this.language);

            this.setAllBooleans(false);
            switch (this.from) {
                case 'eli_assessments':
                    // this.from_admin = true;
                    this.previewMode = true;
                    this.userType = 1;
                    break;
                case 'pending':
                    // this.from_client = true;
                    this.previewMode = false;
                    this.userType = 3;
                    break;
                case 'rater':
                    this.userType = 4;
            }
        });

        const extras = this.router.getCurrentNavigation().extras;
        if (extras && extras.state) {
            this.showBanner = Boolean( extras.state.showBanner);
        }

        // changing the browser url
        window.history.pushState({ 'html': '', 'pageTitle': '' }, '', 'app/assessment');

        // detecting the go back browser button
        location.onPopState(() => {
            console.log('pressed back!');
            if (this.once) {
                setTimeout(() => {
                    this.router.navigate(['/app/client_assessments']);
                }, 100);
            //    window.history.go(-2);
                this.once = false;
            }
        });
    }

    ngOnInit() {
        this.progressRef.start();
        // this.getPageContent(this.assessmentId, this.language);
        if (!this._Globals.previewMode) {
            this.getPageContentByUserType(this.assessmentId, 1, this.language, this.userType, 'pageContent');
        } else {
            this.setPreviewPageContent(this._Globals.instructionsPageContent, 'pageContent');
        }

        this.getAssignedAssessment();
    }

    setPreviewPageContent(content: string, divId: string) {
        this.loading = false;
        setTimeout(() => {
            this.pageContent = content;
            if (String(this.pageContent) === '') {
                this.pageContent = '<div style="text-align:center;margin-top:20px;"><i class="fas fa-exclamation-triangle"></i> No content.</div>';
            }

            $('#' + divId).html(this.pageContent);
            $('.ql-align-justify img').css('width', '100%');
            $('p img').css('margin', '3px 0');
            $('p').css('margin', '0px');

            const w = $(window).width();
            console.log(w);
            if (w < 1260) {
                $('p img').css('display', 'list-item');
            }
        }, 500);
    }

    getAssignedAssessment() {
        this.gettingData.push('getAssignedAssessment');
        this._ClientsService.getAssignedAssessment(this.assignmentId, this.userType).subscribe((_data: any) => {
            console.log('response_GetAssignedAssessment', _data);

            if (this._Globals.validationToken(_data.result.Result)) {
                if (Number(_data.result.Result) !== 0) {
                    const data = JSON.parse(_data.result.Data);
                    this.data = data;
                    this.clientInfo.FirstName = data.ClientInfo.FirstName;
                    this.clientInfo.LastName = data.ClientInfo.LastName;
                    console.log('GetAssignedAssessment', data);
                } else {
                    this.data = this._Globals.previewModeJSON;
                }

                this.progressRef.complete();
            }
            this.gettingData.splice(this.gettingData.indexOf('getAssignedAssessment'), 1);
        });
    }

    ngOnDestroy() {
        console.log('on destroy');
        this.clearAll();
        $('.selectTitle').remove();
        $('.selectMode select').show();
        clearInterval(this.downloadTimer);
        this._Globals.previewMode = false;
    }

    setAllBooleans(status: boolean) {
        this.from_admin = status;
        this.from_client = status;
    }

    getSectionIdPositionIndex(id: number, array: any[]): number {
        for (let i = 0; i < array.length; i++) {
            if (Number(array[i].SectionId) === Number(id)) {
                return i;
            }
        }
    }

    getQuestionIdPositionIndex(id: number, array: any[]): number {
        for (let i = 0; i < array.length; i++) {
            if (Number(array[i].Id) === Number(id)) {
                return i;
            }
        }
    }

    getTotalQuestions(array: any[]): number {
        for (let i = 0; i < array.length; i++) {
            if (array[i].ShowIcons || array[i].SingleChoice) {
                this.questionsTotal += array[i].Questions.length;
            }
        }

        return this.questionsTotal;
    }

    getChoicesForCurrentSection(choiceSetId: number) {
        this.gettingData.push('getAssessmentSectionChoices')
        this._ClientsService.getAssessmentSectionChoices(choiceSetId, this.language).subscribe(data => {
            console.log('response_GetAssessmentSectionChoices', data);
            this.currentSectionChoices = data.result;

            this.gettingData.splice(this.gettingData.indexOf('getAssessmentSectionChoices'), 1);
        });
    }

    setSectionProperties() {
        this.singleChoice = this.sections[this.currentSectionIndex].SingleChoice;
        this.showIcons = this.sections[this.currentSectionIndex].ShowIcons;
        this.displayMode = this.sections[this.currentSectionIndex].DisplayMode;
        console.log('singleChoice', this.singleChoice);
        console.log('showIcons', this.showIcons);
        console.log('DisplayMode', this.displayMode);

        if (this.singleChoice && Number(this.displayMode) === 2) { // this.showIcons &&
            this.multipleQuestions = this.sections[this.currentSectionIndex].Questions;
        }

        if (!this.singleChoice && !this.showIcons) {
            this.questionChoices = this.sections[this.currentSectionIndex].Questions;
            console.log('questionChoices', this.questionChoices);
            for (let i = 0; i < this.questionChoices.length; i++) {
                this.getQuestionChoices(this.questionChoices[i].Id, i);
            }
        }
    }

    getQuestionChoices(questionId: number, idx: number) {
        this.gettingData.push('getQuestionChoices');
        this._ClientsService.getQuestionChoices(questionId, this.language).subscribe(data => {

        this.questionChoices[idx].Choices = data.result;

        if (this.questionChoices[idx].Answer && this.questionChoices[idx].Answer > 0) {

            const choice = this.questionChoices[idx].Choices.find((c: any) => Number(c.Id) === Number(this.questionChoices[idx].Answer));
            if (choice && choice.AllowFreeEntry) {
                this.gettingData.push('getFreeEntryAnswer');
                this._ClientsService.getFreeEntryAnswer(this.questionChoices[idx].Id, this.assignmentId)
                    .subscribe((response: any) => {
                        console.log('response_GetFreeEntryAnswer', response);

                        if (this._Globals.validationToken(response.result.Result)) {
                            if (Number(response.result.Result) !== 0) {
                                $('#input' + this.questionChoices[idx].Id).val(JSON.parse(response.result.Data));
                                $('#input' + this.questionChoices[idx].Id).show();

                                return;
                            }
                            this.toastr.error('We are sorry. Error while get answer.', 'ELI');
                        }
                    },
                    (err) => {
                        this.toastr.error('We are sorry. Error while get answer.', 'ELI');
                        this.gettingData.splice(this.gettingData.indexOf('getFreeEntryAnswer'), 1);
                    },
                    () => {
                        this.gettingData.splice(this.gettingData.indexOf('getFreeEntryAnswer'), 1);
                    });
            } else {
                $('#input' + this.questionChoices[idx].Id).hide();
            }

            return;
        }

            $('#input' + this.questionChoices[idx].Id).hide();
        },
        (err) => {
            this.gettingData.splice(this.gettingData.indexOf('getQuestionChoices'), 1);
        },
        () => {
            this.gettingData.splice(this.gettingData.indexOf('getQuestionChoices'), 1);
        });
    }

    displayDownButtons() {
        const total = $('.isQuestion');
        const w = window.innerWidth;

        if (total.length > 1) {
            if (w < 992) {
                this.responsiveButtons = true;
                this.showDownButtons = true;
            } else {
                this.responsiveButtons = false;
                this.showDownButtons = false;
            }
        } else {
            if (w < 992) {
                this.showDownButtons = true;
                this.responsiveButtons = true;
            } else {
                this.showDownButtons = false;
                this.responsiveButtons = false;
            }
        }
    }

    onResize(event: any) {
        if (!this.finish) {
            if (event.currentTarget.innerWidth < 992) {
                this.showDownButtons = true;
                this.responsiveButtons = true;
            } else {
                this.showDownButtons = false;
                this.responsiveButtons = false;
            }
        } else {
            this.showDownButtons = false;
            this.responsiveButtons = false;
            $('#showDownButtons').hide();
        }

        const w = $(window).width();
        console.log(w);

        if (w < 1260) {
            $('p img').css('display', 'list-item');
        } else {
            $('p img').css('display', 'unset');
        }

        if (localStorage.getItem('ELIResponseError') === '1') {
            setTimeout(() => {
                /*adding disabled class to the back and next buttons*/
                $('.takingAssessment button').addClass('disabled');
            }, 10);
        } else {
            setTimeout(() => {
                /*removing disabled class to the back and next buttons*/
                $('.takingAssessment button').removeClass('disabled');
            }, 10);
        }
    }

    showNextQuestion() {
        if (!this.previewMode) {
            // validate regular questions
            if (!this.validateSingleQuestions()) {
                return;
            }

            // validate satisfaction questions
            if (!this.validateFacesQuestions()) {
                return;
            }

            // validate survey questions
            if (!this.validateSurveyQuestions()) {
                return;
            }
        }

        this.globalCurrentQuestion++;
        // if the current question index is less than the current section length, we display the next question
        // skip checkbox checked: going to the next missing answer, otherwise the regular next below
        if (this.skipToMissingAnswers && this.skipToNextMissingAnswer()) {
            console.log('skipped to the next missing answer', this.currentQuestionIndex);
        } else if (this.currentQuestionIndex < (this.sections[this.currentSectionIndex].Questions.length - 1) &&
           (Number(this.displayMode) !== 2)) {

            const selectedAnswerId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Answer;

            console.log('selected answer id', selectedAnswerId);
            console.log('answers', this.currentSectionChoices);

            $('#' + selectedAnswerId).addClass('active');
            $('#input' + selectedAnswerId).prop('checked', true);

            this.currentQuestionIndex++;
            console.log('currentQuestionIndex', this.currentQuestionIndex);
        } else {
            this.showNextSection();
        }

        if (this.sections.length !== 0) {
            const lastSection = Number(this.sections[this.sections.length - 1].SectionId);
            if (lastSection === this.currentSectionId) {
                // excluiding the multiple choices
                if (!this.singleChoice && !this.showIcons) {
                    this.currentQuestionId =
                        this.sections[this.currentSectionIndex].Questions[this.sections[this.sections.length - 1].Questions.length - 1].Id;
                } else {
                    this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
                }
                console.log('currentQuestionId', this.currentQuestionId);
            } else {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }
        }
    }

    ngDoCheck() {
        this.displayDownButtons();
    }

    showNextSection() {
        if (this.currentSectionIndex < (this.sections.length - 1)) {
            this.currentSectionIndex++;
            if (Number(this.sections[this.currentSectionIndex].Questions.length) === 0) {
                this.showNextSection();
                return;
            }
            const questionsToAdd = this.questionsToAdd(this.currentSectionIndex);
            this.globalCurrentQuestion = questionsToAdd + 1;

            this.currentQuestionIndex = 0;
            this.currentSectionId = this.sections[this.currentSectionIndex].SectionId;
            this.currentChoiceSetId = this.sections[this.currentSectionIndex].ChoiceSetId;
            console.log('------New section-------');
            this.setSectionProperties();
            // excluiding the multiple choices
            if (this.singleChoice || this.showIcons) {
                this.getChoicesForCurrentSection(this.currentChoiceSetId);
            }
            console.log('currentSectionIndex', this.currentSectionIndex);
            console.log('currentQuestionIndex', this.currentQuestionIndex);
            console.log('currentChoiceSetId', this.currentChoiceSetId);
            console.log('Answer', this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Answer);
            this.currentHeader = this.sections[this.currentSectionIndex].Header;
        } else {
            this.assessmentFinished();
        }
    }

    assessmentFinished() {

        console.log('---Assessment finished!---');
        if (!this.previewMode) {
            this.showDownButtons = false;
            this.processAssessment(this.assignmentId);
            this.showAssessment = false;
            this.loading = true;

            if (Number(this.userType) === 3) {
                this.loadingMessage = 'Loading.. Please wait.';
                this.hideNavigationBtns = true;
            }
            if (Number(this.userType) === 4) {
                this.loadingMessage = 'Please wait.';
                this.hideNavigationBtns = true;
            }

            this.clearAll();
        } else {
            console.log('ASSESSMENT Preview finished');
            this.finish = true;
            this.showAssessment = true;
            this.loading = true;
            this.hideNavigationBtns = true;
            this.setPreviewPageContent(this._Globals.thankyouPageContent, 'thankYouPageContent');
            this.showAssessment = false;
        }
        setTimeout(() => {
            this.showDownButtons = false;
            $('#showDownButtons').hide();
        }, 100);
    }

    showPrevQuestion() {
        if (this.globalCurrentQuestion <= 1) { return; }

        // skip checkbox checked: going to the previous missing answer instead of the regular back
        // (when there is none the back button is hidden by showBackButton)
        if (this.skipToMissingAnswers) {
            const prev = this.getMissingPosition(false);
            if (prev) {
                this.goToQuestion(prev.sectionIndex, prev.questionIndex);
            }
            return;
        }

        this.displayDownButtons();
        this.showPrevSection();
    }

    showPrevSection() {
        if (!this.singleChoice || Number(this.currentQuestionIndex) === 0) {
            this.currentSectionIndex--;
            const currentSectionsingleChoice = this.singleChoice;

            this.currentQuestionIndex = this.sections[this.currentSectionIndex].Questions.length;
            this.currentSectionId = this.sections[this.currentSectionIndex].SectionId;
            this.currentChoiceSetId = this.sections[this.currentSectionIndex].ChoiceSetId;
            console.log('------prev section-------');
            this.setSectionProperties();

            if (currentSectionsingleChoice) {
                // if (this.from == 'rater') {
                  //  this.globalCurrentQuestion = 1;
                // } else {
                // excluiding the multiple choices
                if (this.singleChoice || this.showIcons) {
                    this.globalCurrentQuestion--;
                }
                // }
            } else {
                if (this.singleChoice) {
                    this.globalCurrentQuestion = (this.globalCurrentQuestion - 1);
                } else {
                    const questionsToRemove = this.questionsToRemove(this.currentSectionIndex);
                    this.globalCurrentQuestion = (this.globalCurrentQuestion - questionsToRemove);
                }
            }

            // excluiding the multiple choices
            if (this.singleChoice || this.showIcons) {
                this.getChoicesForCurrentSection(this.currentChoiceSetId);
            }
            console.log('currentSectionIndex', this.currentSectionIndex);
            console.log('currentQuestionIndex', this.currentQuestionIndex);
            console.log('currentChoiceSetId', this.currentChoiceSetId);
            this.currentHeader = this.sections[this.currentSectionIndex].Header;
            if (this.displayMode === 1) {
                this.currentQuestionIndex--;
            }
        } else {
            this.currentQuestionIndex--;
            this.globalCurrentQuestion--;
        }

        const lastSection = Number(this.sections[this.sections.length - 1].SectionId);
        if (lastSection === Number(this.currentSectionId)) {
            // excluiding the multiple choices
            if (!this.singleChoice && !this.showIcons) {
                this.currentQuestionId =
                    this.sections[this.currentSectionIndex].Questions[this.sections[this.sections.length - 1].Questions.length - 1].Id;
            } else {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }
            console.log('currentQuestionId', this.currentQuestionId);
        } else {
            if (this.currentQuestionIndex < this.sections[this.currentSectionIndex].Questions.length) {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }
        }
    }

    displayCommentsSection() {
        $('.commentsSection, .commentsTitle').show();
        $('.questionSection, .questionData').hide();
        this.onCommentsPage = true;
    }

    backFromComments() {
        console.log('backFromComments');
        $('.commentsSection, .commentsTitle').hide();
        $('.questionSection, .questionData').show();
        this.onCommentsPage = false;
    }

    finishAssessmentsWithComments() {

        $('#showDownButtons').css('opacity', 0);
        // $('#showDownButtons').remove();
        console.log('remove btns');

        // keeping the comment in case the user has to come back to answer missing questions
        this.commentsText = String($('#commentsArea').val() || '');

        const data = {
            'gr4': this.assignmentId,
            'wl5': this._Globals.getUserId(),
            'vy8': this.commentsText
        };

        this._RatersService.postSaveCommentsData(this._CryptoJs.encrypt(JSON.stringify(data), 'Os6u9y$B&EXH@PcQfTjPtZP4t78!z%7*'))
            .subscribe((_data: any) => {
            console.log('postPreventUseDefaultPassword_response', _data.result.Result);

            switch (_data.result.Result) {
                case 0:
                    this.toastr.error('We are sorry. An unexpected error happened while trying to save the comment', 'ELI');
                    break;

                case 1:
                    this.assessmentFinished();
                    break;
            }
        });
    }


    questionsToAdd(currentSectionIndex: number): number {
        let questionsToAdd = 0;
        for (let i = 0; i < currentSectionIndex; i++) {
            // excluiding the multiple choices
            if (this.sections[i].SingleChoice || this.sections[i].ShowIcons) {
                questionsToAdd += this.sections[i].Questions.length;
            }
        }
        return questionsToAdd;
    }

    questionsToRemove(currentSectionIndex: number): number {
        let questionsToRemove = 0;
        questionsToRemove = this.sections[currentSectionIndex].Questions.length;
        return questionsToRemove;
    }

    finishAssessment() {
        switch (this.userType) {
            case 1:
                this.router.navigate(['/app/edit_eli', this._Globals.previewAssessmentId]);
                break;
            case 3:
                this.router.navigate(['/app/client_assessments']);
                break;
            case 4:
                this.router.navigate(['/app/rater_assessments']);
                break;
        }
    }

    saveAssessmentAnswer(questionId: number, answerId: number): boolean {
        if (Number(this.assignmentId) !== 0) {
            const sectionId = this.sections[this.currentSectionIndex].SectionId;


            const question = new SaveQuestionDto();
            question.AssignedAssessmentId = this.assignmentId;
            question.SectionId = sectionId;
            question.QuestionId = questionId;
            question.Answer = answerId;

            console.log('current question answer', question);

            /*adding disabled class to the answers, back and next buttons*/
            $('.buttons label, .takingAssessment button').addClass('disabled');
            /*disabling the answers, back and next buttons*/
            $('.takingAssessment input, .takingAssessment button').prop('disabled', true);

            // setTimeout(() => {
            this._ClientsService.postSaveAssessmentAnswer(question).subscribe((data: any) => {
                console.log(data);
                $('.buttons i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw').hide();

                if (data.result.Result > 0) {
                    localStorage.setItem('ELIResponseError', '0');
                    /*enabling all buttons*/
                    $('.buttons label, .takingAssessment button').removeClass('disabled');
                    $('.takingAssessment input, .takingAssessment button').prop('disabled', false);

                    return true;
                } else {
                    this.toastr.error('We are sorry. An unexpected error happened while trying to register your answer. Please try again. If the problem persists please contact Technical Support.', 'ELI');
                    /*enabling only answers buttons*/
                    $('.buttons label').removeClass('disabled');
                    $('.takingAssessment input').prop('disabled', false);
                    localStorage.setItem('ELIResponseError', '1');

                    /*remove the selected answer*/
                    $('.buttons label').removeClass('active');
                    return false;
                }
            },
                error => {
                    console.error(error);
                    this._Globals._Toastr.error('We are sorry. An error happened while trying to save the answer. If the problem persists please contact iPEC support team.', 'ELI');
                    /*enabling only answers buttons*/
                    $('.buttons label').removeClass('disabled');
                    $('.takingAssessment input').prop('disabled', false);
                    /*remove the selected answer*/
                    $('.buttons label').removeClass('active');
                    $('.buttons i.fa.fa-spinner.fa-pulse.fa-3x.fa-fw').hide();
                    localStorage.setItem('ELIResponseError', '1');

                    const data = {
                        'he3': 0,
                        'bo7': error.url,
                        'pm5': 'UserId is NaN',
                        'my6': btoa(question + ',' + encodeURIComponent(window.navigator.userAgent))
                    }

                    this._Globals.postSaveAtLog(this._Globals._CryptoJs.encrypt(JSON.stringify(data), '7s6v9y$B&E)M@MxQfTjWnZq4t7x@z%C*'))
                        .subscribe((_data: any) => {
                            console.log('response_postSaveAtLog', _data);
                            this._Globals.validationToken(_data.result.Result);
                    });
                });
            // }, 10000);

        } else {
            console.log('preview mode');
            return false;
        }
    }

    // -----------------------------------------
    // -----validations-------------------------
    // -----------------------------------------


    setOneActive(event: any) {
        console.log('setOneActive', event);
        // if ($(".buttons input").hasClass("disabled")) return;

        $(event.currentTarget.childNodes[3]).css('display', 'inline-block');

        //if (event.currentTarget.nodeName == "LABEL") { }
        /*let answerId = parseInt(event.target.id);*/
        let answerId = event.target.id.match(/\d/g);
        answerId = parseInt(answerId.join(""));

        let children = event.target.parentNode.parentNode.children.length;
        for (let i = 0; i < children; i++) {
            // let lastClass = event.target.parentNode.parentNode.children[i].children["0"].classList.length
            event.target.parentNode.parentNode.children[i].children['0'].classList.remove('active');
        }
        event.target.classList.add('active');
        // .target.parentNode.parentNode.children[3].children["0"].classList

        const questionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
        this.saveAssessmentAnswer(questionId, answerId);
        // setting the current selected answer
        this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Answer = answerId;
    }

    validateSingleQuestions(): boolean {
        if (Number(this.displayMode) === 1 && this.singleChoice) {
            const answer = $('input[name=answers]:checked').val();
            console.log(answer);
            if (answer === undefined) {
                // alert('Please select one answer');
                this.toastr.warning('Please select one answer.', 'ELI');
                return false;
            } else {
                $('input[name=answers]').prop('checked', false);
                $('.btn-group label').removeClass('active');
                return true;
            }
        } else {
            return true;
        }
    }

    selectFace(event: any, questionIndex: string) {
        // console.log(this._ams.sections[this.currentSection].questions[this.currentQuestion]);
        const answerId = parseInt(event.target.dataset.choiceId, 10);
        const questionId = parseInt(event.target.dataset.questionId, 10);

        console.log('choiceId', questionId);
        console.log('answerId', answerId);

        const children = event.target.parentNode.parentNode.children.length;
        for (let i = 0; i < children; i++) {
            event.target.parentNode.parentNode.children[i].children['0'].classList.remove('active');
        }
        event.target.classList.add('active');
        // console.log(event);
        this.setSelectedFaceValue(questionIndex, event.target.classList['0'], answerId);

        this.saveAssessmentAnswer(questionId, answerId);
        // .target.parentNode.parentNode.children[3].children["0"].classList
        // setting the current selected answer
        this.setSelectedQuestionAnswer(questionId, answerId);
    }

    setSelectedQuestionAnswer(questionId: number, answerId: number) {
        for (let i = 0; i < this.sections[this.currentSectionIndex].Questions.length; i++) {
            if (Number(this.sections[this.currentSectionIndex].Questions[i].Id) === Number(questionId)) {
                this.sections[this.currentSectionIndex].Questions[i].Answer = answerId;
                return;
            }
        }
    }

    setSelectedFaceValue(questionIndex: string, classValue: string, answerId: number) {
        $('input[name=\'face' + questionIndex + '\']').val(classValue);
        $('input[name=\'face' + questionIndex + '\']').prop('checked', true);
        console.log(classValue);
    }

    validateFacesQuestions(): boolean {
        if (Number(this.displayMode) === 2 && this.singleChoice) {
            let allCompleted = true;
            const sectionQuestions = this.sections[this.currentSectionIndex].Questions.length;
            for (let i = this.globalCurrentQuestion; i < this.globalCurrentQuestion + sectionQuestions; i++) {
                const answer = String($('input[name=\'face' + i + '\']').val());
                if (answer === '') {
                    // alert('Please complete all questions');
                    this.toastr.warning('Please complete all questions.', 'ELI');
                    allCompleted = false;
                    return allCompleted;
                }
            }
            return allCompleted;
        } else {
            return true;
        }
    }

    selectSurvey(selected: any, event: any) {
        // getting the question id
        const questionId = event.target.id;
        const numRegex = /\d/g; // Change this line
        const result = questionId.match(numRegex);
        console.log(result);
        const id = parseInt(result.join(''), 10);
        console.log('questionId', id);

        // getting the position on the array
        const index = this.sections[this.currentSectionIndex].Questions.findIndex(x => x.Id === id);

        // getting the entire object for the current question
        const currentQuestion = this.sections[this.currentSectionIndex].Questions[index];
        console.log('current question', currentQuestion);

        currentQuestion.RelateQuestionRules.forEach((item) => {
            this.executeRelatedRules(item.RelatedQuestion);
        });

        const selectedValue = selected;
        console.log('survey selected', selectedValue);

        // validation for index 0 of the options
        if (String(selectedValue) !== '') {
            this.saveAssessmentAnswer(id, parseInt(selectedValue, 10));
        }

        // setting the current selected answer
        this.setSelectedQuestionAnswer(id, selected);

        // if allow free entry
        const choice = currentQuestion.Choices.find((c: any) => Number(c.Id) === Number(selected));
        if (choice && choice.AllowFreeEntry) {
            $('#input' + currentQuestion.Id).val('');
            $('#input' + currentQuestion.Id).show();
        } else {
            $('#input' + currentQuestion.Id).hide();

            this._ClientsService.postRemoveFreeEntryAnswer(currentQuestion.Id, this.assignmentId)
                .subscribe((response: any) => {
                    console.log('response_postRemoveFreeEntryAnswer', response);
                    if (this._Globals.validationToken(response.result.Result)) {
                        return;
                    }

                    this.toastr.error('We are sorry.  An error happened while change answer.  Please contact customer support.', 'ELI');
                },
                (err) => {
                    this.toastr.error('We are sorry.  An error happened while change answer.  Please contact customer support.', 'ELI');
                });
        }
    }

    validateSurveyQuestions(): boolean {
        if (!this.showIcons && !this.singleChoice) {
            const selects = this.selectsElement.nativeElement.getElementsByTagName('select');

            let allSelected = true;
            for (let i = 0; i < selects.length; i++) {
                const questionId = selects[i].id;
                const numRegex = /\d/g; // Change this line
                const result = questionId.match(numRegex);
                console.log(result);
                const id = parseInt(result.join(''), 10);
                console.log('questionId', id);

                this.executeRelatedRules(id);

                if (String(selects[i].className) === 'isMandatory' && String(selects[i].parentNode.parentNode.style.display) !== 'none') {
                    const input: any = document.getElementById('input' + id);

                    if (String(input.style.display) !== 'none' && input.value === '') {
                        this.toastr.warning('Please complete all of the mandatory questions.', 'ELI');
                        setTimeout(() => {
                            input.focus();
                            input.style.setProperty('box-shadow', '0px 0px 15px 3px #4d9fd5');
                            input.style.setProperty('-webkit-box-shadow', '0px 0px 15px 3px #4d9fd5');
                        }, 5);

                        setTimeout(() => {
                            input.style.setProperty('box-shadow', 'none');
                            input.style.setProperty('-webkit-box-shadow', 'none');
                        }, 2505);

                        return false;
                    }

                    if (Number(selects[i].selectedIndex) === 0) {
                        this.toastr.warning('Please complete all of the mandatory questions.', 'ELI');
                        allSelected = false;
                    }
                }
            }
            return allSelected;
        } else {
            return true;
        }
    }

    executeRelatedRules(relatedQuestionId: number) {

        // getting the position on the array
        const index = this.sections[this.currentSectionIndex].Questions.findIndex(x => x.Id === relatedQuestionId);

        if (index === -1) {
            return;
        }

        // let currentIndex = parseInt(selects[i].dataset.index);
        const currentQuestion = this.sections[this.currentSectionIndex].Questions[index];
        if (currentQuestion.Rules.length > 0) {
            console.log(`relatedQuestionId ${relatedQuestionId} Have Rules`, currentQuestion);

            let conditionsCounter = 0;
            const conditions = currentQuestion.Rules[0].Conditions;
            let meetsCondition = false;
            while (conditionsCounter < conditions.length) {
                const e = document.getElementById('select' + conditions[conditionsCounter].RelatedQuestion);
                const condition1 = $(`#select${conditions[conditionsCounter].RelatedQuestion}`).val();
                const condition2 = conditions[conditionsCounter].ChoiceId;
                // tslint:disable-next-line: triple-equals
                if (condition1 == condition2) {
                    meetsCondition = true;
                }
                conditionsCounter++;
            }

            if (meetsCondition) {
                if (Number(currentQuestion.Rules[0].RuleType) === 1) { // visibility
                    $('#label' + relatedQuestionId).parent().parent().hide();
                } else if (Number(currentQuestion.Rules[0].RuleType) === 2) { // mandatory
                    this.sections[this.currentSectionIndex].Questions[index].IsMandatory = true;
                    // selects[i].classList.add("isMandatory");
                }
            } else {
                if (Number(currentQuestion.Rules[0].RuleType) === 1) { // visibility
                    $('#label' + relatedQuestionId).parent().parent().show();
                } else if (Number(currentQuestion.Rules[0].RuleType) === 2) { // mandatory
                    this.sections[this.currentSectionIndex].Questions[index].IsMandatory = false;
                    // selects[i].classList.remove("isMandatory");
                }
            }

        }
    }

    clearAll() {
        this.currentSectionIndex = 0;
        this.currentQuestionIndex = 0;
        this.showNextIcon = false;
        this.sections = [];
        this.currentSectionChoices = [];
        this.multipleQuestions = [];
        this.questionChoices = [];
        this.questionsContent = false;

        console.log('All clear!!');
    }


    /*FINISH*/
    processAssessment(assignmentId: number) {
        const processAssessmentDto = new ProcessAssessmentDto();
        processAssessmentDto.assignmentId = assignmentId;
        processAssessmentDto.userType = this.userType;

        this._ClientsService.postProcessAssessment(processAssessmentDto).subscribe(data => {
            console.log('response_PostProcessAssessment', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (Number(data.result.Result) === 0) {
                    this.toastr.error('We are sorry.  An error happened while processing the assessment.  Please contact customer support.', 'ELI');
                    return;
                }
                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                // missing answers, the user must go back to the first unanswered question
                if (Number(_data.Result) === -2) {
                    if (!_data.Assessment) {
                        this.toastr.error('We are sorry.  An error happened while processing the assessment.  Please contact customer support.', 'ELI');
                        return;
                    }

                    const missingAnswers = _data.MissingAnswers || [];
                    this.data = _data.Assessment;
                    if (this.data.Progress == null && missingAnswers.length > 0) {
                        this.data.Progress = {
                            CurrentSection: missingAnswers[0].SectionId,
                            CurrentQuestion: missingAnswers[0].QuestionId
                        };
                    }

                    // total for the message and the list used by the skip checkbox
                    this.missingAnswersCount = missingAnswers.length;
                    this.missingAnswers = missingAnswers;
                    this.showMissingAnswers = true;
                    this.loading = false;
                    console.log('ASSESSMENT has missing answers', missingAnswers);
                    return;
                }

                this.assessmenProcess = _data.AssessmentResults;
                console.log('assessmen Process', this.assessmenProcess);
                console.log('ERPGraphicOptions', this.ERPGraphicOptions);

                if (this.assessmenProcess == null) {
                    this.assessment360Finished = true;
                    this.loading = false;
                    // this.final360Message = "Thank you for your participation!";
                    // call the service for thank you page
                    console.log('ASSESSMENT 360 finished successfully');
                    this.getPageContentByUserType(this.assessmentId, 2, this.language, this.userType, 'thankYou360PageContent');
                    return;
                }

                this.assessmenProcess.forEach((x) => {
                    switch (x.Id) {
                        case 1: {
                            this.ARL = x;
                            break;
                        }
                        case 2: {
                            this.EP = x;
                            this.graphicTitle1 = x.Name;
                            break;
                        }
                        case 3: {
                            this.ESR = x;
                            this.graphicTitle2 = x.Name;
                            break;
                        }
                    }
                });


                // graphic1
                const erData = [];
                this.EP.Values.forEach((x) => {
                    erData.unshift(x.Value);
                });

                this.EP.Values.forEach((x) => {
                    this.ERGraphicLabel.unshift(`                                   `);
                    this.levels1.unshift(x.Value);
                });


                this.ERGraphicDatasets = [
                    {
                        data: erData,
                        label: 'Energy Value'
                    }
                ];


                // Graphic2
                const erpData = [];
                this.ESR.Values.forEach((x) => {
                    erpData.unshift(x.Value);
                });

                this.ESR.Values.forEach((x) => {
                    this.ERPGraphicLabel.unshift(`                                   `);
                    this.levels2.unshift(x.Value);
                });

                this.ERPGraphicDatasets = [
                    {
                        data: erpData,
                        label: 'Energy Value'
                    }
                ];

                this.finish = true;
                this.loading = false;
                this.showAssessment = true;


                // call the service for thank you page
                console.log('ASSESSMENT finished successfully');
                this.getPageContentByUserType(this.assessmentId, 2, this.language, this.userType, 'thankYouPageContent');
            }



        });
    }

    // button of the missing answers page (-2): restores the screen state changed when finishing,
    // loads the assessment again on the first missing answer and prepares the skip checkbox list
    goToMissingAnswer() {
        this.showMissingAnswers = false;
        this.reviewingMissingAnswers = true;
        this.hideNavigationBtns = false;
        this.questionsContent = true;
        this.showNextIcon = true;
        this.onCommentsPage = false;
        // getTotalQuestions accumulates over questionsTotal
        this.questionsTotal = 0;
        this.loadingMessage = 'Loading Asessment, please wait...';

        // loads the assessment again using the Progress returned by ProcessAssessment
        this.userReady();
        // after the sections are loaded, the missing answers can be located for the skip checkbox
        this.setMissingPositions();
    }

    // position (section and question index) of every missing answer returned by ProcessAssessment
    setMissingPositions() {
        // starting empty, in case the assessment returns -2 more than once
        this.missingPositions = [];

        // converting the section and question ids into indexes of the sections array, ignoring the ones not found
        this.missingAnswers.forEach((missing) => {
            const sectionIndex = this.getSectionIdPositionIndex(missing.SectionId, this.sections);
            if (sectionIndex === undefined) { return; }

            const questionIndex = this.getQuestionIdPositionIndex(missing.QuestionId, this.sections[sectionIndex].Questions);
            if (questionIndex === undefined) { return; }

            this.missingPositions.push({ sectionIndex, questionIndex });
        });

        // same order the user sees the questions, so next and previous follow the assessment
        this.missingPositions.sort((a, b) => a.sectionIndex - b.sectionIndex || a.questionIndex - b.questionIndex);
    }

    // next or previous missing answer from the current question, null when there is none
    getMissingPosition(next: boolean) {
        const section = this.currentSectionIndex;
        const question = this.currentQuestionIndex;

        if (next) {
            // first missing answer after the current question
            for (let i = 0; i < this.missingPositions.length; i++) {
                const p = this.missingPositions[i];
                if (p.sectionIndex > section || (p.sectionIndex === section && p.questionIndex > question)) {
                    return p;
                }
            }
        } else {
            // last missing answer before the current question
            for (let i = this.missingPositions.length - 1; i >= 0; i--) {
                const p = this.missingPositions[i];
                if (p.sectionIndex < section || (p.sectionIndex === section && p.questionIndex < question)) {
                    return p;
                }
            }
        }

        return null;
    }

    // moves directly to a question, leaving the screen as if the user had navigated one by one
    goToQuestion(sectionIndex: number, questionIndex: number) {
        const sectionChanged = sectionIndex !== this.currentSectionIndex;
        const question = this.sections[sectionIndex].Questions[questionIndex];

        // current position, section data, question number and section type
        this.currentSectionIndex = sectionIndex;
        this.currentQuestionIndex = questionIndex;
        this.currentSectionId = this.sections[sectionIndex].SectionId;
        this.currentChoiceSetId = this.sections[sectionIndex].ChoiceSetId;
        this.currentHeader = this.sections[sectionIndex].Header;
        this.currentQuestionId = question.Id;
        this.globalCurrentQuestion = this.questionsToAdd(sectionIndex) + questionIndex + 1;
        this.setSectionProperties();

        // each section has its own choices, if it is the same section the existing answer is checked
        // so the next validation doesn't take it as unanswered
        if (sectionChanged) {
            this.getChoicesForCurrentSection(this.currentChoiceSetId);
        } else if (Number(question.Answer) > 0) {
            $('#input' + question.Answer).prop('checked', true);
        }
    }

    // returns false when there is nothing to skip, so the regular next is executed
    skipToNextMissingAnswer(): boolean {
        // there is a missing answer ahead, going to it
        const next = this.getMissingPosition(true);
        if (next) {
            this.goToQuestion(next.sectionIndex, next.questionIndex);
            return true;
        }

        // no more missing answers, going to the last page of the assessment
        const last = this.sections.length - 1;
        const lastSection = this.sections[last];

        // last section with single questions (no demographics): going to its last question,
        // unless the user is already there and the regular finish must be executed
        if (lastSection.SingleChoice && Number(lastSection.DisplayMode) === 1) {
            const lastQuestion = lastSection.Questions.length - 1;
            if (this.currentSectionIndex === last && this.currentQuestionIndex === lastQuestion) {
                return false;
            }
            this.goToQuestion(last, lastQuestion);
            return true;
        }

        // demographics section: if the user is already there the regular finish is executed
        if (this.currentSectionIndex >= last) {
            return false;
        }

        // standing one section before the last one, so showNextSection loads the last section as usual
        this.currentSectionIndex = last - 1;
        this.showNextSection();
        return true;
    }

    // used by the back buttons of the questions (desktop and responsive)
    showBackButton(): boolean {
        // first question, there is nothing to go back to
        if (this.globalCurrentQuestion <= 1) {
            return false;
        }

        // skipping, there is no previous missing answer to go back to
        if (this.skipToMissingAnswers && !this.getMissingPosition(false)) {
            return false;
        }

        return true;
    }

    isCurrentQuestionMissing(): boolean {
        if (!this.reviewingMissingAnswers || !this.singleChoice || Number(this.displayMode) !== 1) {
            return false;
        }

        const section = this.sections[this.currentSectionIndex];
        const question = section ? section.Questions[this.currentQuestionIndex] : null;

        return !!question && !(Number(question.Answer) > 0);
    }

    downloadAssessment() {
        console.log('download_assessment');

        window.location.href =
            'https://eli-services.softcial.net/AdminService.svc/GetAssessmentReport?clientId=3&assignmentId=' + this.assignmentId;
    }



    // ---------------------------------------------------
    // -------------------instructions--------------------
    // ---------------------------------------------------

    userReady() {
        this.ready = true;

        const w = window.innerWidth;
        if (w < 992) {
            this.showDownButtons = true;
            this.responsiveButtons = true;
        } else {
            this.showDownButtons = false;
            this.responsiveButtons = false;
        }
        if (Number(this.assignmentId) !== 0) {
            console.log('_data', this.data);

            this.sections = this.data.Sections;
            this.showCommentsSection = this.data.ShowCommentsSection;
            console.log('sections', this.sections);

            if (Number(this.sections[0].Questions.length) === 0) {
                this.finish = true;
                this.toastr.warning('This assessment does\'t have sections to show.', 'ELI');
                return;
            }

            if (this.data.Progress == null) {
                this.currentSectionId = 0;
                this.currentQuestionId = 0;
            } else {
                this.currentSectionId = this.data.Progress.CurrentSection;
                this.currentQuestionId = this.data.Progress.CurrentQuestion;
            }

            if (Number(this.currentSectionId) !== 0) {
                this.currentSectionIndex = this.getSectionIdPositionIndex(this.currentSectionId, this.data.Sections);
                this.currentQuestionIndex =
                    this.getQuestionIdPositionIndex(this.currentQuestionId, this.data.Sections[this.currentSectionIndex].Questions);
                const questionsToAdd = this.questionsToAdd(this.currentSectionIndex);

                if (Number(this.currentSectionIndex) === 0) {
                    // if (this.from == 'rater') {
                    //     this.globalCurrentQuestion = 1;
                    // } else {
                        this.globalCurrentQuestion = this.currentQuestionIndex + 1;
                    // }
                } else {
                    this.globalCurrentQuestion = questionsToAdd + this.currentQuestionIndex + 1;
                }
            } else {
                // for new assessment
                this.currentSectionIndex = 0;
                this.currentQuestionIndex = 0;
                this.currentSectionId = this.sections[0].SectionId;
            }

            this.currentChoiceSetId = this.data.Sections[this.currentSectionIndex].ChoiceSetId;
            this.currentHeader = this.data.Sections[this.currentSectionIndex].Header;
            this.setSectionProperties();

            this.questionsTotal = this.getTotalQuestions(this.data.Sections);

            console.log('currentChoiceSetId', this.currentChoiceSetId);
            console.log('currentSectionId', this.currentSectionId);
            console.log('currentQuestionId', this.currentQuestionId);
            console.log('currentSectionIndex', this.currentSectionIndex);
            console.log('currentQuestionIndex', this.currentQuestionIndex);
            console.log('total questions', this.questionsTotal);

            this.getChoicesForCurrentSection(this.currentChoiceSetId);

            const lastSection = Number(this.sections[this.sections.length - 1].SectionId);
            if (lastSection === Number(this.currentSectionId)) {
                // excluiding the multiple choices
                if (!this.singleChoice && !this.showIcons) {
                    this.currentQuestionId =
                        this.sections[this.currentSectionIndex].Questions[this.sections[this.sections.length - 1].Questions.length - 1].Id;
                } else {
                    this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
                }
                console.log('currentQuestionId', this.currentQuestionId);
            } else {
                this.currentQuestionId = this.sections[this.currentSectionIndex].Questions[this.currentQuestionIndex].Id;
            }

            this.showAssessment = true;
            this.loading = false;

            setTimeout(() => {
                if (!this.singleChoice && !this.showIcons) {
                    this.sections[this.currentSectionIndex].Questions.forEach((item) => {
                        this.executeRelatedRules(item.Id);
                    });
                }
            }, 1000);
        } else {
            console.log('preview JSON', this._Globals.previewModeJSON);
            if (this._Globals.previewModeJSON === undefined) {
                this.toastr.warning('No assigned Assessment loaded', 'ELI');
                return;
            } else {
                this.sections = this._Globals.previewModeJSON.result.Sections;

                this.currentSectionIndex = 0;
                this.currentQuestionIndex = 0;
                this.currentSectionId = this.sections[0].SectionId;
                this.currentChoiceSetId = this.sections[0].ChoiceSetId;

                this.setSectionProperties();

                this.questionsTotal = this.getTotalQuestions(this._Globals.previewModeJSON.result.Sections);

                if (Number(this.questionsTotal) === 0) {
                    this.showAssessment = true;
                    this.loading = false;
                    this.finish = true;
                    console.log('assessment doesn\'t have questions');
                    return;
                }

                console.log('currentChoiceSetId', this.currentChoiceSetId);
                console.log('currentSectionId', this.currentSectionId);
                console.log('currentQuestionId', this.currentQuestionId);
                console.log('currentSectionIndex', this.currentSectionIndex);
                console.log('currentQuestionIndex', this.currentQuestionIndex);
                console.log('total questions', this.questionsTotal);

                if (Number(this.sections[this.currentSectionIndex].Questions.length) === 0) {
                    this.showNextSection();
                    this.showAssessment = true;
                    this.loading = false;
                    return;
                } else {
                    this.getChoicesForCurrentSection(this.currentChoiceSetId);
                    this.showAssessment = true;
                    this.loading = false;
                }
            }
        }
    }

    getIndexForCurrentQuestion(): number {
        return this.sections[this.currentSectionIndex].Questions.findIndex(x => x.Id === this.currentQuestionId);
    }

    getPageContentByUserType(assessmentId: number, pageType: number, language: string, userType: any, divId: string) {
        this.gettingData.push('getPageContentByUserType');
        this._AssessmentsService.getPageContentByUserType(assessmentId, pageType, language, userType, this.assignmentId)
            .subscribe((data: any) => {
                console.log('response_getPageContent', data);

                this.loading = false;

                if (this.finish || this.assessment360Finished) {
                    this.showDownButtons = false;
                    $('#showDownButtons').remove();
                }

                if (this._Globals.validationToken(data.result.Result)) {
                    const _data = JSON.parse(data.result.Data);
                    console.log('getPageContent', _data);
                    this.pageContent = _data.Content;
                    if (String(this.pageContent) === '') {
                        this.pageContent = '<div style="text-align:center;margin-top:20px;"><i class="fas fa-exclamation-triangle"></i> No content.</div>';
                    }

                    $('#' + divId).html(this.pageContent);
                    $('.ql-align-justify img').css('width', '100%');
                    $('p img').css('margin', '3px 0');
                    $('p').css('margin', '0px');

                    const w = $(window).width();
                    console.log(w);
                    if (w < 1260) {
                        $('p img').css('display', 'list-item');
                    }

                }
                this.gettingData.splice(this.gettingData.indexOf('getPageContentByUserType'), 1);
            },
            (err) => {
                this.gettingData.splice(this.gettingData.indexOf('getPageContentByUserType'), 1);
        });
    }

    saveFreeEntryAnswer(questionChoiceId: number, event: any): void {
       if (!questionChoiceId) {
        return;
       }
       const answer = String(event.target.value).trim();

       if (!answer || answer.trim().length === 0) {
        if (this.questionChoices.find(q => q.Id === questionChoiceId).IsMandatory) {
            $('#input' + questionChoiceId).val('');
        }
       }

       this._ClientsService.postSaveFreeEntryAnswer(questionChoiceId, this.assignmentId, answer)
        .subscribe((response: any) => {
            console.log('response_postSaveFreeEntryAnswer', response);
            if (this._Globals.validationToken(response.result.Result)) {
                return;
            }

            this.toastr.error('We are sorry.  An error happened while processing your answer.  Please contact customer support.', 'ELI');
        },
        (error) => {
            this.toastr.error('We are sorry.  An error happened while processing your answer.  Please contact customer support.', 'ELI');
        });
    }
}
